import { useEffect, useState, useRef } from 'react';
import { appointmentConst, agendaConst } from '../../../../../constants';
import { adultHasNoPhone } from '../../../../../util';
import { useSelector } from 'react-redux';
import { label } from '../../../../../constants/Forms';

export const useCustomerValidations = ({
  customer,
  role,
  option,
  treatmentTypeId,
  appointmentById,
  openModal,
}) => {
  const { configs } = useSelector((state) => state.configs);
  const [showAlert, setShowAlert] = useState(false);
  const [disabledButton, setDisableButton] = useState(false);
  const [haveNotes, setHaveNotes] = useState(false);
  const [message, setMessage] = useState('');
  const [description, setDescription] = useState('');
  const [type, setType] = useState();

  const notesModalShown = useRef(false);
  const blacklistModalShown = useRef(false);
  const adultModalShown = useRef(false);

  useEffect(() => {
    const hideStrikeAlert = () => {
      setShowAlert(false);
      setMessage('');
      setDescription('');
      setType(undefined);
    };

    if (!customer) {
      setHaveNotes(false);
      setDisableButton(false);
      hideStrikeAlert();
      return;
    }

    const phoneAdultValidation = adultHasNoPhone(customer);
    const strikes = configs.strikeAppointment;
    const lessStrike = strikes - 1;

    if (customer?.notes?.length) {
      setHaveNotes(true);

      if (!notesModalShown.current) {
        openModal(appointmentConst.NOTES_ALERT_TYPE);
        notesModalShown.current = true;
      }
    }

    if (customer?.blackList && !blacklistModalShown.current) {
      openModal(appointmentConst.BLACKLIST_ALERT_TYPE);
      blacklistModalShown.current = true;
    }

    if (phoneAdultValidation && !adultModalShown.current) {
      openModal(appointmentConst.IS_ADULT_ALERT_TYPE);
      adultModalShown.current = true;
    }

    if (!treatmentTypeId) {
      hideStrikeAlert();
      setDisableButton(false);
      return;
    }

    const cancellations = customer?.cancellations;

    if (cancellations === lessStrike) {
      setShowAlert(true);
      setMessage(label.warningTitleStrike(lessStrike, strikes));
      setDescription(label.warningDescriptionStrike(lessStrike));
      setType('warning');
    } else if (cancellations === strikes) {
      setShowAlert(true);
      setMessage(label.errorTitleStrike(cancellations, strikes));
      setDescription(label.errorDescriptionStrike);
      setType('error');
    } else {
      hideStrikeAlert();
    }

    if (
      cancellations >= strikes &&
      option !== agendaConst.purchasedProducts
    ) {
      setDisableButton(true);
    } else if (['absence', 'finished'].includes(appointmentById?.status)) {
      setDisableButton(true);
    } else {
      setDisableButton(false);
    }
  }, [
    customer,
    role,
    option,
    treatmentTypeId,
    appointmentById,
    openModal,
    configs.strikeAppointment,
  ]);

  return {
    showAlert,
    disabledButton,
    haveNotes,
    message,
    description,
    type,
  };
};
